import { apiGetSignalsData } from "@/Groups/Signals/private/api/apiGetSignalsData";

const Signals = {
  namespaced: true,

  state: { 
    data: {},
    map: [],
    next: null,
  },

  actions: {
    //Метод инициализации сигналов
    async initSignals({ state, commit, dispatch }){
      await dispatch('getSignals');
      if (Object.keys(state.data).length === 0) return;
      commit('SET_READY_FLAG');
    },

    //Получаем список сигналов
    async getSignals({ commit }){
      commit('TOGGLE_LOADING_FLAG', true);
      try{
        const data = await apiGetSignalsData();
        commit('CLEAR_DATA');
        commit('SET_DATA', data.results);
        commit('SET_NEW_LINK', data.next);
        commit('SORT_SIGNALS');
      } catch (error) {
        console.error('Ошибка при добавлении нового сигнала:', error);
      } finally{
        commit('TOGGLE_LOADING_FLAG', false);
      }
    },
  },

  mutations: {
    //Добавлям данные в хранилище
    SET_DATA(state, { favorites, list }){
      favorites.forEach(signal => {
        if(!state.map.includes(signal.id)){
          state.data[signal.id] = signal;
          state.map.push(signal.id);
        }
      });
      list.forEach(signal => {
        if(!state.map.includes(signal.id)){
          state.data[signal.id] = signal;
          state.map.push(signal.id);
        }
      });
    },

    //Сортировка сигналов
    SORT_SIGNALS(state) {
      state.map.sort((a, b) => {
        const signalA = state.data[a];
        const signalB = state.data[b];
        const priorityA = Number(signalA.pinned) * 2 + Number(signalA.trending);
        const priorityB = Number(signalB.pinned) * 2 + Number(signalB.trending);
        if (priorityA !== priorityB) return priorityB - priorityA;
        const dateA = new Date(signalA.publication_date || signalA.created_at);
        const dateB = new Date(signalB.publication_date || signalB.created_at);
        return dateB - dateA;
      });
    },

    //Очистить данные
    CLEAR_DATA(state){
      state.data = {};
      state.map = [];
      state.next = null;
    },

    //Отмечаем, что данные сигналов готовы к использованию
    SET_READY_FLAG(state){ 
      state.isReady = true; 
    },
    
    //Отмечаем, что начался/закончился процесс получения данных с сервера
    TOGGLE_LOADING_FLAG(state, status){ 
      state.isLoading = status; 
    },

    //Указать ссылку на следующую страницу
    SET_NEW_LINK(state, link){ state.next = link; },
  },

  getters: {
    //Получить массив ID сигналов в отсортированном порядке
    map: (state) => state.map,
    
    //Получить объект со всеми сигналами
    data: (state) => state.data,
    
    //Получить ссылку на следующую страницу
    next: (state) => state.next,
    
    //Получить избранные сигналы
    favorites: (state) => {
      return state.map
        .filter(id => {
          const signal = state.data[id];
          return signal?.reactions?.bookmarked?.is_mine === true;
        })
        .map(id => state.data[id]);
    },
    
    //Получить все остальные сигналы (НЕ избранные)
    otherSignals: (state) => {
      return state.map
        .filter(id => {
          const signal = state.data[id];
          return signal?.reactions?.bookmarked?.is_mine !== true;
        })
        .map(id => state.data[id]);
    }
  }
}

export default Signals;